import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { users: Array };
  static targets = ['container', 'template', 'select', 'message', 'hiddenMessage'];

  connect() {
    this.ensureSingleInitialSelector();
  }

  add() {
    let clone;
    if (this.templateTarget.tagName === 'TEMPLATE') {
      clone = this.templateTarget.content.cloneNode(true);
    } else {
      // For hidden div, clone its first child
      clone = this.templateTarget.firstElementChild.cloneNode(true);
    }

    const select = clone.querySelector('select');
    this.fillOptions(select);

    if (this.hasMessageTarget) {
      const msg = this.messageTarget.value;
      const hidden = clone.querySelector("[data-report-collaborators-target='hiddenMessage']");
      if (hidden) hidden.value = msg;
    }

    this.containerTarget.appendChild(clone);
    this.sync();
  }

  remove(event) {
    event.target.closest('div.mb-3').remove();
    this.sync();
  }

  sync() {
    const selectedIds = this.selectTargets.map((s) => s.value).filter(Boolean);
    const users = this.normalizedUsers();

    this.selectTargets.forEach((select) => {
      const currentValue = select.value || '';
      select.innerHTML = '';

      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = '';
      select.appendChild(blank);

      users.forEach(({ id, label }) => {
        const idStr = String(id);
        if (!selectedIds.includes(idStr) || idStr === currentValue) {
          const opt = document.createElement('option');
          opt.value = idStr;
          opt.textContent = label;
          if (idStr === currentValue) opt.selected = true;
          select.appendChild(opt);
        }
      });
    });

    if (this.hasMessageTarget) {
      const msg = this.messageTarget.value;
      this.hiddenMessageTargets.forEach((h) => (h.value = msg));
    }
  }

  fillOptions(select) {
    const users = this.normalizedUsers();

    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = '';
    select.appendChild(blank);

    users.forEach(({ id, label }) => {
      const opt = document.createElement('option');
      opt.value = id;
      opt.textContent = label;
      select.appendChild(opt);
    });
  }

  normalizedUsers() {
    return (this.usersValue || [])
      .map((user) => {
        if (Array.isArray(user)) {
          return { label: user[0], id: user[1] };
        }

        return {
          label: user?.label || user?.name_with_email || user?.name || user?.email || '',
          id: user?.id,
        };
      })
      .filter((user) => user.id !== undefined && user.id !== null && user.id !== '');
  }

  ensureSingleInitialSelector() {
    const rows = this.containerTarget.querySelectorAll('.mb-3');

    if (rows.length === 0) {
      this.add();
      return;
    }

    if (rows.length > 1) {
      rows.forEach((row, index) => {
        if (index > 0) row.remove();
      });
      this.sync();
    }
  }
}
